var exports = {
  "wk": "commitMessageContainer__HCH_5X",
  "nU": "commitBranchContainer__wieILg",
  "Mr": "commitFilesChangedContainer__pzBsSQ",
  "mm": "commit-header-actions__PiJ49A",
  "FB": "PageHeader_TitleArea__hGu18F",
  "ok": "PageHeader_Title__BHDgrO",
  "Fi": "browseFilesTooltip__LKPP5o",
  "Es": "browseFilesButton__OnCHxj",
};

module.exports = exports;
